import { round } from '../../utils/round';

const precisionZeroCurrencies = ['CLP', 'INR', 'JPY', 'KRW'];

export function currencyRound(number: number, currency: string): number {
  return round(number, currencyRoundPrecision(number, currency));
}

export function currencyRoundPrecision(number: number, currency: string): number {
  const precisionZero = precisionZeroCurrencies.includes(currency);
  return precisionZero && number % 1 === 0 ? 0 : 2;
}
